export default __webpack_public_path__ + "16a57d6eb1023ccc4d807d6115038cb7.png";